<template>
    <div class="x_tab">

        <div class="tab_wrapper">
            <div
                v-for="(item, index) in list"
                :key="index"
                :class="['tabitem',index == selectIndex ? 'active' : '',(index == 0 || index == list.length-1) ?'':'space']"
                @click="clickTab(index)"
            >
                {{ item.label }}
            </div>
        </div>

        <div v-for="(item, index) in drawTabCon" :key="index">
            <slot
                :name="'x' + index"
                v-if="item.mark == selectIndex"
                class="con"
            ></slot>
        </div>

    </div>
</template>

<script>
export default {
    name: "",
    props: {
        data: Array,
    },
    computed: {
        list() {
            return this.data;
        },
        drawTabCon() {
            return this.data.map((item, index) => {
                return {
                    label: item.label,
                    mark: index,
                };
            });
        },
    },
    data() {
        return {
            selectIndex: 0,
            timer: 0,
        };
    },
    created() {},
    mounted() {
        // console.log(this.drawTabCon)
        // console.log(this.$props);
        // this.play();
    },
    destroyed() {
        clearTimeout(this.timer);
    },
    methods: {
        clickTab(index) {
            this.selectIndex = index;
        },
        play() {
            //自动播放
            this.timer = setInterval(() => {
                this.selectIndex++;
                if (this.selectIndex > this.list.length - 1) {
                    this.selectIndex = 0;
                }
            }, 10000);
        },
    },
    components: {},
};
</script>
<style lang="less" scoped>
.x_tab {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    font-size: 22px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #e8f9ff;
}

.tab_wrapper {
    position: absolute;
    top: 160px;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background: rgba(0, 0, 0, 0.5);
    height: 80px;
    // padding: 0 163px;
    .tabitem {
        width: 260px;
        font-size: 22px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        text-align: center;
        position: relative;
        color: #e8f9ff;
        height: 64px;
        line-height: 64px;
        box-shadow: 0px 0px 10px 1px rgba(0, 222, 255, 0.8) inset;
        border-radius: 10px;
    }
    .active {
        box-shadow: 0px 0px 10px 7px #02DFFF inset;
        border-radius: 10px;
    }
}
.con {
    background: #f1f4f6;
    color: red;
}
</style>